import React from "react";
import { motion } from "framer-motion";
import { Sparkles, ArrowRight } from "lucide-react";
import { useHOH, STEP } from "../../../context/StyleContext";
import StepFrame from "../StepFrame";

export default function IntroScreen() {
  const { goTo } = useHOH();
  return (
    <StepFrame className="text-center">
      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6 }}
        className="w-20 h-20 mx-auto rounded-3xl glass flex items-center justify-center mb-8">
        <Sparkles className="w-9 h-9 text-hoh-rose" />
      </motion.div>
      <p className="text-[12px] uppercase tracking-[0.4em] font-semibold text-hoh-rose">Occasion & Style OS</p>
      <h1 className="mt-5 text-6xl md:text-8xl font-black tracking-tight text-black leading-[0.95]">
        HOH <span className="italic font-semibold text-hoh-rose">AI</span>
      </h1>
      <p className="mt-6 text-lg md:text-xl text-hoh-slate max-w-xl mx-auto leading-relaxed">
        Prepare for life’s important moments with AI-designed grooming, fashion and content.
      </p>
      <button onClick={() => goTo(STEP.OCCASION)} className="btn-royal mt-10" data-testid="start-experience-btn">
        Start Experience <ArrowRight className="w-4 h-4" />
      </button>
    </StepFrame>
  );
}
